import { OwcIconButton, OwcListItem, OwcMenu } from "@one/react";
import moment from "moment";
import { useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { withApollo, compose } from "react-apollo";
import {statusGetter} from "./Utils";


const CoverMenuItem = styled.div`
  height: 0.973480224609375px;
  width: 100%;
  border-radius: 0;
  background: var(--one-color-gray-300);
`;

const BookingMenuAction = ({ params, handlers }) => {
  const {
    deleteEquipment,
    editBooking,
    setRowEquipmentId,
    setPopupEnableStatus, // eslint-disable-next-line no-unused-vars
    handleApprove,
    handleReject
  } = handlers;
  const [anchorEl, setAnchorEl] = useState(false);
  const data = params?.data;
  const uniqueAnchorId = `drop-booking-menu-${data?.id}`;
  const user = useSelector((store) => store.user);
  const currentTimeString = moment.tz(user.timezone).utc().format();

  const handleSettingClose = () => {
    setAnchorEl(false);
  };

  const handleSettingClick = (event, params) => {
    setRowEquipmentId(data?.id);
    setAnchorEl(event.currentTarget);
  };

  // Check if booking is pending approval (hazardous or requires assistance)
  // If no approval object exists but booking has hazardous materials or requires assistance, treat as pending
  const approvalStatus = data?.approval?.status?.toString().toUpperCase();

  const isPendingApproval = approvalStatus === 'PENDING';

  const isAdmin = user?.roles?.some((role) => role === 'BookingAdmin');

  const isBookingStatusCancelled = statusGetter(params) === 'Cancelled';

  return (
    <>
      <OwcIconButton
        icon="more_vertical"
        type="legacy"
        flat
        onClick={(event) => {
          handleSettingClick(event, params);
        }}
        id={uniqueAnchorId}
      />
      {anchorEl &&
        ReactDOM.createPortal(
          <OwcMenu
            data-testid="simple-menu"
            anchor={uniqueAnchorId}
            visible={anchorEl}
            onClickOutside={handleSettingClose}
            disablePortal={true}
            disabled={!data?.active}
          >
            <OwcListItem
              data-testid="simple-menu-filter"
              onClick={() => {
                setAnchorEl(null);
                setPopupEnableStatus(true);
                editBooking(data);
              }}
              disabled={
                isBookingStatusCancelled || (isAdmin ? false : (
                  !data?.active ||
                  data?.checkInDone ||
                  (data?.checkInRequired && data.checkInStartsAt <= new Date().getTime() / 1000)
                ))
              }
            >
              Edit
            </OwcListItem>
            <CoverMenuItem />
            <OwcListItem
              data-testid="simple-menu-filter"
              onClick={() => {
                setAnchorEl(null);
                deleteEquipment({
                  id: data?.id,
                });
              }}
              disabled={
                isBookingStatusCancelled || (isAdmin ? !data?.active : (
                  !data?.active ||
                  (!isAdmin && data?.dateFrom < currentTimeString) || // Only restrict past bookings for non-admins
                  (!isAdmin && data?.dateTo < currentTimeString) // Only restrict past bookings for non-admins
                ))
              }
            >
              Cancel
            </OwcListItem>
            {isPendingApproval && isAdmin && (
              <>
                <CoverMenuItem />
                <OwcListItem
                  data-testid="simple-menu-approve"
                  onClick={() => {
                    setAnchorEl(null);
                    if (handleApprove) {
                      handleApprove(data);
                    }
                  }}
                  disabled={isBookingStatusCancelled || !isPendingApproval}
                >
                  Approve
                </OwcListItem>
                <CoverMenuItem />
                <OwcListItem
                  data-testid="simple-menu-reject"
                  onClick={() => {
                    setAnchorEl(null);
                    if (handleReject) {
                      handleReject(data);
                    }
                  }}
                  disabled={isBookingStatusCancelled || !isPendingApproval}
                >
                  Reject
                </OwcListItem>
              </>
            )}
          </OwcMenu >,
          document.body
        )}
    </>
  );
};
export default compose(withApollo)(BookingMenuAction);
